import _extends from "@babel/runtime/helpers/esm/extends";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { MenuHeader } from '../Menu';
/**
 * @param {import('@wp-g2/create-styles').ViewOwnProps<import('../Menu/MenuHeader').Props, 'div'>} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function DropdownMenuHeader(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'DropdownMenuHeader'),
      otherProps = _extends({}, _useContextSystem);

  return /*#__PURE__*/React.createElement(MenuHeader, Object.assign({}, otherProps, {
    ref: forwardedRef
  }));
}

export default contextConnect(DropdownMenuHeader, 'DropdownMenuHeader');